import React from "react";

export const DummyHeader = () => {
  return (
    <div
      id="cefcom-globalheader"
      data-clickregion="global-header"
      data-version="2.2.5"
      className={"cefcom-global-header-wrapper --no-shadow "}
    >
      <div
        data-clicksubregion="topbar"
        className="cefcom-top-bar --react
    
    
    "
        style={{ paddingRight: 0, marginRight: 0 }}
      >
        <div className="cefcom-top-bar__wrapper">
          <header className="cefcom-top-bar__inner ">
            <div className="cefcom-top-bar__col -left">
              <a href="#" className="cefcom-top-bar__top-link">
                <span className="topbar-menu-toggle cefcom-icon -menu" />
                <span className="cefcom-top-bar__top-link-text" />
                <span className="cefcom-top-bar__top-link-text">menu</span>
                <span className="cefcom-top-bar__top-link-text" />
                <span className="cefcom-top-bar__top-link-text" />
              </a>
            </div>
            <div className="cefcom-top-bar__col -center ef-header__col-logo">
              <a href="/" className="cefcom-top-bar__logo">
                <span
                  style={{
                    backgroundImage:
                      'url("https://a.storyblok.com/f/61891/x/aa166bd9ab/00.svg")',
                  }}
                  className="cefcom-top-bar__logo-black"
                />
                <span
                  style={{
                    backgroundImage:
                      'url("https://a.storyblok.com/f/61891/x/7d00ecae9d/00.svg")',
                  }}
                  className="cefcom-top-bar__logo-white"
                />
              </a>
            </div>
            <div
              className="cefcom-top-bar__col -right -no-phone-number"
              style={{ paddingRight: 8 }}
            >
              <a href="tel:05017431438" className=" cefcom-top-bar__top-link">
                <span className=" cefcom-top-bar__top-link-text">
                  050-1743-1438
                </span>
                <span className=" cefcom-icon -phone" />
              </a>
            </div>
          </header>
          <div className="ef-header__top-global-menu">
            <div className="gc-menu__container">
              <div className="ef-container">
                <div className="gc-menu__wrapper">
                  <ul className="gc-topbar__item-group js-gc-topbar-item-group dropdown">
                    <li className="gc-topbar__item">
                      <a
                        href="/"
                        className="gc-bar-menu-btn"
                        data-short-text="Home"
                      >
                        <div className="item-content__wrapper">
                          <span className="item-icon">
                            <svg
                              className="gc-icon gc-bar-btn__icon-home"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 18 23"
                              id="gh-home"
                              width="100%"
                              height="100%"
                            >
                              <path
                                d="M.5 9.207V22.5h17V9.207L9 .707l-8.5 8.5z"
                                stroke="#191919"
                              />
                            </svg>
                          </span>
                          <p className="item-title">Home</p>
                          <div className="item-text__wrapper">
                            <span className="item-text">Welcome to EF</span>
                            <div className="item-text--hover" />
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="gc-topbar__item">
                      <a
                        href="/pg/"
                        className="gc-bar-menu-btn"
                        data-short-text="Program"
                      >
                        <div className="item-content__wrapper">
                          <span className="item-icon">
                            <svg
                              className="gc-icon gc-bar-btn__icon-programmes"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 11 22"
                              id="gh-programmes"
                              width="100%"
                              height="100%"
                            >
                              <path
                                d="M3.436.5l-2.863 21h6.99l2.864-21h-6.99z"
                                opacity=".8"
                              />
                            </svg>
                          </span>
                          <p className="item-title">Program</p>
                          <div className="item-text__wrapper">
                            <span className="item-text">All programs</span>
                            <div className="item-text--hover" />
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="gc-topbar__item">
                      <a
                        href="/contact/"
                        className="gc-bar-menu-btn"
                        data-short-text="Office"
                      >
                        <div className="item-content__wrapper">
                          <span className="item-icon">
                            <svg
                              className="gc-icon gc-bar-btn__icon-offices"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 15 21"
                              id="gh-offices"
                              width="100%"
                              height="100%"
                            >
                              <path
                                d="M7.5 1C11.09 1 14 3.985 14 7.667 14 10.12 11.833 14.566 7.5 21 3.167 14.566 1 10.121 1 7.667 1 3.985 3.91 1 7.5 1z"
                                stroke="#191919"
                              />
                            </svg>
                          </span>
                          <p className="item-title">Office</p>
                          <div className="item-text__wrapper">
                            <span className="item-text">
                              Find an office near me
                            </span>
                            <div className="item-text--hover" />
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="gc-topbar__item">
                      <a
                        href="/about-us/"
                        className="gc-bar-menu-btn"
                        data-short-text="About us"
                      >
                        <div className="item-content__wrapper">
                          <span className="item-icon">
                            <svg
                              className="gc-icon gc-bar-btn__icon-about-ef"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 22 24"
                              id="gh-about-ef"
                              width="100%"
                              height="100%"
                            >
                              <path
                                d="M11 11a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm10 12H1c0-5.523 4.477-10 10-10s10 4.477 10 10z"
                                stroke="#191919"
                              />
                            </svg>
                          </span>
                          <p className="item-title">About us</p>
                          <div className="item-text__wrapper">
                            <span className="item-text">What is EF</span>
                            <div className="item-text--hover" />
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="gc-topbar__item">
                      <a
                        href="//careers.ef.com"
                        className="gc-bar-menu-btn"
                        data-short-text="Recruitment information"
                      >
                        <div className="item-content__wrapper">
                          <span className="item-icon">
                            <svg
                              className="gc-icon gc-bar-btn__icon-careers"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 19"
                              id="gh-careers"
                              width="100%"
                              height="100%"
                            >
                              <path
                                d="M6.5 6.5v6h-6v6h19V.5h-7v6h-6z"
                                stroke="#191919"
                              />
                            </svg>
                          </span>
                          <p className="item-title">Recruitment information</p>
                          <div className="item-text__wrapper">
                            <span className="item-text">Apply</span>
                            <div className="item-text--hover" />
                          </div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="ef-header__top-global-menu-mobile">
            <section className="gc-layer-global-mobile-nav gc-layer gc-layer-global-mobile-nav--shown">
              <div className="gc-layer__container">
                <nav className="gc-global-mobile-nav" id="global-mobile-nav">
                  <ul className="gc-global-mobile-nav__list slide">
                    <li className="gc-global-mobile-nav__item">
                      <a
                        href="/"
                        className="gc-global-mobile-nav__anchor gc-global-mobile-nav__anchor--"
                      >
                        <div className="mobile-menu-content__wrapper">
                          <p className="mobile-menu-title">Home</p>
                          <span className="mobile-menu-text">
                            Welcome to EF
                          </span>
                        </div>
                      </a>
                    </li>
                    <li className="gc-global-mobile-nav__item">
                      <a
                        href="/pg/"
                        className="gc-global-mobile-nav__anchor gc-global-mobile-nav__anchor--"
                      >
                        <div className="mobile-menu-content__wrapper">
                          <p className="mobile-menu-title">Program</p>
                          <span className="mobile-menu-text">All programs</span>
                        </div>
                      </a>
                    </li>
                    <li className="gc-global-mobile-nav__item">
                      <a
                        href="/contact/"
                        className="gc-global-mobile-nav__anchor gc-global-mobile-nav__anchor--"
                      >
                        <div className="mobile-menu-content__wrapper">
                          <p className="mobile-menu-title">Office</p>
                          <span className="mobile-menu-text">
                            Find an office near me
                          </span>
                        </div>
                      </a>
                    </li>
                    <li className="gc-global-mobile-nav__item">
                      <a
                        href="/about-us/"
                        className="gc-global-mobile-nav__anchor gc-global-mobile-nav__anchor--"
                      >
                        <div className="mobile-menu-content__wrapper">
                          <p className="mobile-menu-title">About us</p>
                          <span className="mobile-menu-text">What is EF</span>
                        </div>
                      </a>
                    </li>
                    <li className="gc-global-mobile-nav__item">
                      <a
                        href="//careers.ef.com"
                        className="gc-global-mobile-nav__anchor gc-global-mobile-nav__anchor--"
                      >
                        <div className="mobile-menu-content__wrapper">
                          <p className="mobile-menu-title">
                            Recruitment information
                          </p>
                          <span className="mobile-menu-text">Apply</span>
                        </div>
                      </a>
                    </li>
                  </ul>
                  <ul className="gc-global-mobile-nav__list mobile-menu-bottom-cta">
                    <li className="gc-global-mobile-nav__item">
                      <a href="/highschool/infomeetings/" className="">
                        Study abroad information session
                      </a>
                    </li>
                    <li className="gc-global-mobile-nav__item">
                      <a href="/highschool/brochure/" className="">
                        Click here to request materials
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </section>
          </div>
        </div>
      </div>
      <div className="cefcom-product-header --react  ">
        <div
          data-clicksubregion="site-header"
          id="product-header"
          className="cefcom-product-header__container"
        >
          <div className="cefcom-product-header__block-sitetitle">
            <span className="cefcom-product-header__title">
              <a href="/highschool/">EF DUMMY NAV</a>
            </span>
            <span className="cefcom-product-header__subtitle">
              <a href="/highschool/">
                This dummy component shows ondev for visual purposes only.
              </a>
            </span>
          </div>
          <div
            className="cefcom-product-header__block-cta"
            style={{ paddingRight: 0 }}
          >
            <div className="cta-block">
              <a
                className="-primary-mobile cefcom-button  gh-bar-btn gc-bar-btn gc-bar-btn -rounded-btn -not-featured-btn ef-button -primary-mobile"
                href="/highschool/infomeetings/"
              >
                Infomeetings
              </a>
              <a
                className="-primary-mobile cefcom-button  ef-button -primary -primary-mobile"
                href="/highschool/brochure/"
              >
                Request a brochure
              </a>
            </div>
          </div>
          <span className="cefcom-product-header__block-menu-toggle">
            <span className="ef-icon -chevron-down" />
          </span>
        </div>
      </div>
      <div
        data-clicksubregion="site-menu"
        className="cefcom-product-menu--react"
      >
        <div id="ef-product-menu">
          <nav className="ef-nav">
            <ul className="ef-nav__menu">
              <li className="ef-nav__item    -with-sub-menu   ">
                <a className="ef-nav__link " href="#">
                  Destination
                </a>
                <ul className="ef-nav__sub-menu">
                  <li className="ef-nav__item  ef-nav__sub-link   ">
                    <a
                      className="ef-nav__link "
                      href="/highschool/destinations/ireland/"
                    >
                      Ireland
                    </a>
                  </li>
                  <li className="ef-nav__item  ef-nav__sub-link   ">
                    <a
                      className="ef-nav__link "
                      href="/highschool/destinations/usa/"
                    >
                      America
                    </a>
                  </li>
                  <li className="ef-nav__item  ef-nav__sub-link   ">
                    <a
                      className="ef-nav__link "
                      href="/highschool/destinations/great-britain/"
                    >
                      England
                    </a>
                  </li>
                </ul>
              </li>
              <li className="ef-nav__item     ">
                <a
                  className="ef-nav__link "
                  href="/highschool/exchange-with-ef/"
                >
                  Overview
                </a>
              </li>
              <li className="ef-nav__item     ">
                <a className="ef-nav__link " href="/highschool/consultation/">
                  Inquiries
                </a>
              </li>
              <li className="ef-nav__item -with-sub-menu -more-btn">
                <a className="ef-nav__link" href="#">
                  Others
                </a>
                <ul className="ef-nav__sub-menu" />
              </li>
            </ul>
            <div className="ef-block__ctas">
              <a
                className="primary-mobile -primary-mobile  ef-button  gh-bar-btn gc-bar-btn gc-bar-btn -rounded-btn -not-featured-btn ef-button -primary-mobile"
                href="/highschool/infomeetings/"
              >
                Infomeetings
              </a>
              <a
                className="primary-mobile -primary-mobile  ef-button  ef-button -primary -primary-mobile"
                href="/highschool/brochure/"
              >
                Request a brochure
              </a>
            </div>
          </nav>
        </div>
      </div>
      <div id="ef-menu-mobile-gud" className="ef-product-menu--react">
        <div data-clicksubregion="site-menu-mobile">
          <nav className="ef-nav">
            <ul className="ef-nav__menu">
              <li className="ef-nav__item    -with-sub-menu   ">
                <a className="ef-nav__link " href="#">
                  Destination
                </a>
                <ul className="ef-nav__sub-menu">
                  <li className="ef-nav__item  ef-nav__sub-link   ">
                    <a
                      className="ef-nav__link "
                      href="/highschool/destinations/ireland/"
                    >
                      Ireland
                    </a>
                  </li>
                  <li className="ef-nav__item  ef-nav__sub-link   ">
                    <a
                      className="ef-nav__link "
                      href="/highschool/destinations/usa/"
                    >
                      America
                    </a>
                  </li>
                  <li className="ef-nav__item  ef-nav__sub-link   ">
                    <a
                      className="ef-nav__link "
                      href="/highschool/destinations/great-britain/"
                    >
                      England
                    </a>
                  </li>
                </ul>
              </li>
              <li className="ef-nav__item     ">
                <a
                  className="ef-nav__link "
                  href="/highschool/exchange-with-ef/"
                >
                  Overview
                </a>
              </li>
              <li className="ef-nav__item     ">
                <a className="ef-nav__link " href="/highschool/consultation/">
                  Inquiries
                </a>
              </li>
            </ul>
            <div className="ef-block__ctas">
              <a
                className="primary-mobile -primary-mobile  ef-button  gh-bar-btn gc-bar-btn gc-bar-btn -rounded-btn -not-featured-btn ef-button -primary-mobile"
                href="/highschool/infomeetings/"
              >
                留学説明会
              </a>
              <a
                className="primary-mobile -primary-mobile  ef-button  ef-button -primary -primary-mobile"
                href="/highschool/brochure/"
              >
                資料請求はこちら
              </a>
            </div>
          </nav>
        </div>
      </div>
      <div
        data-clicksubregion="sticky-bar"
        className="cefcom-sticky-bar --with-sticky-header "
      >
        <div className="sticky-bar  ">
          <div className="ef-container sticky-bar__container">
            <div className="sticky-bar__logo -left ">
              <h3 className="sticky-bar__logo-label">
                <a href="/highschool/">EF DUMMY NAV</a>
              </h3>
            </div>
            <div className="sticky-bar__ctas -right ">
              <a
                className="gh-bar-btn gc-bar-btn gc-bar-btn -rounded-btn -not-featured-btn ef-button -primary-mobile ef-button --small "
                href="/highschool/infomeetings/"
              >
                This dummy component shows ondev for visual purposes only.
              </a>
              <a
                className="ef-button -primary -primary-mobile ef-button --small "
                href="/highschool/brochure/"
              >
                資料請求はこちら
              </a>
              <a href="tel:05017431438" className="ef-header__top-link">
                <span className="ef-header__top-link-text">050-1743-1438</span>
                <span className="ef-header__icon -ml ef-icon -phone" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <span />
    </div>
  );
};
